import type { OilPhaseVolumeFactorBoCalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const oilPhaseVolumeFactorBoCalculator: OilPhaseVolumeFactorBoCalculator =
  params => {
    const {
      gasSpecificGravity,
      oilSpecificGravity,
      temperatureInRankine,
      temperatureF,
      oilAPI,
      inSituPressurePSIA,
      bubblePointPressurePSIA,
      solutionGasRsoInSitu,
      gasOilRatio
    } = params;

    const { a } = solutionGasRsoCalculator(params);

    // D76: =D8*((J18/18.2+1.4)*10^(-D64))^1.204819
    let solutionGasPbRsb =
      gasSpecificGravity *
      ((bubblePointPressurePSIA / 18.2 + 1.4) * 10 ** -a) ** 1.204819;
    solutionGasPbRsb =
      solutionGasPbRsb > gasOilRatio ? gasOilRatio : solutionGasPbRsb;

    // D78: =(-1433+5*D76+17.2*D15-1180*D8+12.61*D7)/((10^5)*D3)
    const oilCompressibilityUnSatCo =
      (-1433 +
        5 * solutionGasPbRsb +
        17.2 * temperatureInRankine -
        1180 * gasSpecificGravity +
        12.61 * oilAPI) /
      (10 ** 5 * inSituPressurePSIA);
    // D80: =0.9759+0.00012*(D76*((D8/D17)^0.5)+1.25*D4)^1.2
    const oilFormationVolumeFactorPbBop =
      0.9759 +
      0.00012 *
        (solutionGasPbRsb * (gasSpecificGravity / oilSpecificGravity) ** 0.5 +
          1.25 * temperatureF) **
          1.2;
    // D82: =D80*EXP(D78*(J18-D3))
    const oilFormationVolumeFactorUnSatBo =
      oilFormationVolumeFactorPbBop *
      Math.exp(
        oilCompressibilityUnSatCo *
          (bubblePointPressurePSIA - inSituPressurePSIA)
      );
    // D74: =0.9759+0.00012*(J12*((D8/D17)^0.5)+1.25*D4)^1.2
    const oilFormationVolumeFactorSatBo =
      0.9759 +
      0.00012 *
        (solutionGasRsoInSitu *
          (gasSpecificGravity / oilSpecificGravity) ** 0.5 +
          1.25 * temperatureF) **
          1.2;
    return {
      solutionGasPbRsb,
      oilCompressibilityUnSatCo,
      oilFormationVolumeFactorPbBop,
      oilFormationVolumeFactorSatBo,
      oilFormationVolumeFactorUnSatBo
    };
  };
